(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP_MS = 90;

  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.grid__item:not(.aw-fade)'));
    if (!cards.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        var batch = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--aw-delay', batch * STEP_MS + 'ms');
          entry.target.classList.add('aw-fade--in');
          batch++;
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    cards.forEach(function (card) {
      card.classList.add('aw-fade');
      io.observe(card);
    });
  }

  function boot() {
    document.querySelectorAll('[data-aw-fade]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme Editor: re-tag the cards of a reloaded section.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-aw-fade]');
    if (root) init(root);
  });
})();
